import { NavigationMenu } from "radix-ui";
import { FC } from "react";
import useAuthRoute from "~/hook/useAuthRoute";
import { useFontStyle } from "~/hook/useFontStyle";
import { cn } from "~/lib/utils";
import { BLUR_HASH, FALLBACK_IMAGE_URL } from "~/utils/constant";
import { wantsDesktop } from "~/utils/helper-funcations";
import ImageWithSkeleton from "../ImageWithSkeleton";
import { PropsType } from "../mobile-menu/type";

export const GRID_ITEMS: Record<string, string> = {
  narrow: "grid-cols-1 ",
  wide: "grid-cols-2 ",
};
const ListItem: FC<PropsType> = ({ data, category_name, displayItem, isImagePreloaded }) => {
  // const { LocalizedLink } = useLocale();
  const { medium, regular } = useFontStyle();
  const { handleNavigate } = useAuthRoute();

  return (
    <div className={cn("menu_parent_card  h-auto pb-2 px-3", displayItem === "wide" ? "w-[500px]" : "w-[350px]", category_name ? "pt-7" : "pt-2")}>
      {category_name && (
        <div className="flex items-center justify-between mb-2">
          <h2 className={cn("icon_category_type", medium)}>{category_name}</h2>
        </div>
      )}

      <div className={cn("grid gap-2.5 ", GRID_ITEMS[displayItem])}>
        {data.map((item) => {
          const isVisible = wantsDesktop(item.show_menu);
          return (
            isVisible && (
              <NavigationMenu.Link asChild key={item.id}>
                <div
                  className="group border border-[#E5E7EB] bg-white rounded-lg flex items-center gap-x-1 cursor-pointer transition-all duration-200 hover:scale-[1.02] hover:shadow-lg"
                  onClick={() => handleNavigate(item.navigate_to)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleNavigate(item.navigate_to);
                    }
                  }}
                >
                  <div className="border-r-1 border-r-[#E5E7EB] px-3 py-1">
                    <ImageWithSkeleton
                      url={{
                        small: typeof item.img === "string" ? item.img : item.img?.s?.url || FALLBACK_IMAGE_URL,
                        medium: typeof item.img === "string" ? item.img : item.img?.m?.url || FALLBACK_IMAGE_URL,
                        large: typeof item.img === "string" ? item.img : item.img?.l?.url || FALLBACK_IMAGE_URL,
                        hd: typeof item.img === "string" ? item.img : item.img?.hd?.url || FALLBACK_IMAGE_URL,
                        original: typeof item.img === "string" ? item.img : item.img?.og?.url || FALLBACK_IMAGE_URL,
                      }}
                      width={100}
                      height={100}
                      alt={item.name ?? "Icon"}
                      className={cn("max-w-[100px] max-h-[100px] object-cover")}
                      loadImageLazy={false}
                      isPreloaded={isImagePreloaded?.(typeof item.img === "string" ? item.img : item.img?.s?.url || "") || false}
                      useSkeletonLoader={true}
                    />
                  </div>
                  <p className={cn("icon_category_name capitalize !text-start group-hover:text-dailyDarshanChipColor transition-colors", regular)}>
                    {item.name}
                  </p>
                </div>
              </NavigationMenu.Link>
            )
          );
        })}
      </div>
    </div>
  );
};

export default ListItem;
